import { UUID_REGEX } from "@/helpers/common";

export type SearchClassification = "uuid" | "email" | "phone" | "semantic";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[\d\s().+-]{7,}$/;

export function classifySearchQuery(query: string): SearchClassification {
  const trimmed = query.trim();

  if (UUID_REGEX.test(trimmed)) {
    return "uuid";
  }

  if (EMAIL_REGEX.test(trimmed)) {
    return "email";
  }

  if (PHONE_REGEX.test(trimmed)) {
    return "phone";
  }

  return "semantic";
}
